import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { API_BASE } from "../config";
import { apiFetch } from "../utilities/apiFetch";
import { TIPOS_CASO, ETIQUETAS_FUENTE, explicarTecleado } from "../utilities/conciliacionBancaria";
import { ACCIONES_CASO, ESTADOS_CASO, MIN_JUSTIFICACION, datoDelComprobante, EJEMPLO_JUSTIFICACION, avisoProbable } from "../utilities/casosPlantel";

// Modulo "Casos por corregir" del cajero (roles 2 y 3). Son los casos que Financieros publico a su plantel a partir
// de los reportes del banco. El cajero no captura lo que dice el banco: el servidor lo toma del cobro guardado.
// Cada accion pide una justificacion y queda en la bitacora (cMultipagosCasos.php).

const dinero = (n) => `$${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const fechaCorta = (iso) => (iso ? `${String(iso).substring(8, 10)}/${String(iso).substring(5, 7)}/${String(iso).substring(0, 4)}` : "");
const estiloTarjeta = { border: "1px solid #ddd", borderRadius: "8px", padding: "14px", backgroundColor: "#fff", boxShadow: "0 2px 4px rgba(0,0,0,0.05)", marginBottom: "12px" };
const estiloDato = { fontSize: "0.85rem", margin: "2px 0" };
const estiloEtiqueta = { fontSize: "0.75rem", color: "#666" };
const conceptosTexto = (lista) => (lista && lista.length ? ` · concepto${lista.length > 1 ? "s" : ""} ${lista.join(", ")}` : "");
const estiloAviso = { fontSize: "0.85rem", backgroundColor: "#fff8e1", border: "1px solid #ffe082", color: "#7a5c00", borderRadius: "4px", padding: "8px 10px", margin: "8px 0" };
const datoDe = (p) => `${p.medioCobro === "Ventanilla Banorte" || p.medioCobro === "Ventanilla BBVA" ? "folio" : "autorización"} ${p.dato}`;
const ESTADO_CAJERO = { PENDIENTE: "Pendiente", CORREGIDO: "Corregido: se confirmará con el siguiente archivo del banco", RESPONDIDO: "Respondido: Financieros lo revisará" };

const VistaCasosPlantel = ({ onActualizarConteo = () => {} }) => {
  const [casos, setCasos] = useState(null);
  const [error, setError] = useState("");
  const [abierto, setAbierto] = useState(null); // { caso, accion }
  const [motivo, setMotivo] = useState("");
  const [extra, setExtra] = useState("");
  const [enviando, setEnviando] = useState(false);

  const cargar = async () => {
    setError("");
    try {
      const res = await apiFetch(`${API_BASE}/wMultipagosCasosPlantel.php`);
      const json = await res.json();
      if (!json.success) { setError(json.message || "No se pudieron consultar los casos."); setCasos([]); return; }
      setCasos(json.data);
      onActualizarConteo(json.data);
    } catch (e) {
      setError("No hubo respuesta del servidor. Intenta de nuevo.");
      setCasos([]);
    }
  };
  useEffect(() => { cargar(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const abrir = (caso, accion) => { setAbierto({ caso, accion }); setMotivo(""); setExtra(""); };
  const pide = abierto ? ACCIONES_CASO[abierto.accion].pide : null;
  // Para "Ligar": las ordenes pendientes del alumno de la referencia (las busca el servidor) o, si la referencia no
  // dice el alumno, las ordenes pendientes del plantel por ese importe creadas cerca del cobro
  // Para "Reasignar": la orden del otro alumno que marco el cruce
  const delOtro = abierto && abierto.accion === "REASIGNAR" ? ((abierto.caso.datos || {}).otras || [])
    .map((o) => ({ id: o.orden, folio_registro: o.folio, importe_total: o.monto, matricula: o.matricula })) : [];
  const delAlumno = abierto ? (delOtro.length ? delOtro : abierto.caso.candidatas || []) : [];
  const delPlantel = abierto && !delAlumno.length ? ((abierto.caso.datos || {}).posibles || [])
    .map((o) => ({ id: o.orden, folio_registro: o.folio, importe_total: o.monto, fecha_creacion: o.creada, matricula: o.matricula })) : [];
  const candidatas = delAlumno.length ? delAlumno : delPlantel;
  const listo = motivo.trim().length >= MIN_JUSTIFICACION && (!pide || extra.trim() !== "");

  const enviar = async () => {
    setEnviando(true);
    try {
      const res = await apiFetch(`${API_BASE}/wMultipagosCasoAtender.php`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id_caso: abierto.caso.id, accion: abierto.accion, motivo: motivo.trim(), [pide || "extra"]: extra.trim() }),
      });
      const json = await res.json();
      if (!json.success) { Swal.fire("No se pudo", json.message || "El servidor no aceptó el cambio.", "error"); return; }
      setAbierto(null);
      Swal.fire("Listo", json.message, "success");
      cargar();
    } catch (e) {
      Swal.fire("Error", "No hubo respuesta del servidor. Intenta de nuevo.", "error");
    } finally {
      setEnviando(false);
    }
  };

  if (casos === null) return <div className="Dashboard-card"><p>Cargando casos...</p></div>;

  return (
    <div className="Dashboard-card">
      <h3 style={{ marginBottom: "5px", color: "#003b5c" }}>Casos por corregir</h3>
      <p style={{ color: "#666", fontSize: "0.9rem", marginTop: 0 }}>
        Financieros revisó los reportes del banco y encontró estas diferencias con lo que tu plantel registró en Multipagos. Lo que dice el
        banco ya está en el sistema: solo confirma la acción y escribe la justificación. Todo queda registrado.
      </p>
      {error && <div style={{ padding: "10px", backgroundColor: "#fdecea", border: "1px solid #f5c6cb", color: "#7a1c1c", borderRadius: "4px", fontSize: "0.85rem" }}>{error}</div>}
      {!casos.length && !error && <div style={{ padding: "10px", backgroundColor: "#e8f5e9", border: "1px solid #c8e6c9", color: "#1b5e20", borderRadius: "4px" }}>Tu plantel no tiene casos por corregir.</div>}

      {casos.map((c) => {
        const d = c.datos || {};
        const tipo = TIPOS_CASO[c.tipo] || { titulo: c.tipo };
        return (
          <div key={c.id} style={{ ...estiloTarjeta, borderLeft: `5px solid ${c.estado === "PENDIENTE" ? (c.vencido ? "#c62828" : "#ef6c00") : "#2e7d32"}` }}>
            <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", flexWrap: "wrap" }}>
              <b>{tipo.titulo}{d.probable ? " (probable)" : ""}</b>
              <span style={{ fontSize: "0.85rem", color: c.vencido ? "#c62828" : "#555", fontWeight: c.vencido ? "bold" : "normal" }}>
                {c.vencido ? `Venció el ${fechaCorta(c.fecha_limite)}` : `Vence el ${fechaCorta(c.fecha_limite)}`}
              </span>
            </div>
            {d.probable && <div style={estiloAviso}>{avisoProbable(d)}</div>}
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: "8px", marginTop: "8px" }}>
              {d.deLaValidacion ? (
                <div>
                  {/* Casos que salen de una validacion del plantel: lo de la izquierda es lo que se valido, no el banco */}
                  <div style={estiloEtiqueta}>LO QUE SE VALIDÓ EN EL PLANTEL</div>
                  <p style={estiloDato}>{d.medioCobro || ETIQUETAS_FUENTE[c.fuente]} · validada el {fechaCorta(d.fecha)} {d.hora} · <b>{dinero(d.importe)}</b></p>
                  {c.orden_capturado && <p style={estiloDato}>Se capturó: <b>{c.orden_capturado}</b></p>}
                  <div style={{ ...estiloEtiqueta, marginTop: "6px" }}>LO QUE DICE EL BANCO</div>
                  {d.otra ? (
                    <p style={estiloDato}>Ese cobro es un <b>{d.otra.medioCobro.toLowerCase()}</b> del {fechaCorta(d.otra.fecha)} {d.otra.hora} ({dinero(d.otra.importe)}) y <b>ya está registrado en la orden {d.otra.orden}</b>.</p>
                  ) : <p style={estiloDato}>No tiene un cobro con ese dato.</p>}
                </div>
              ) : (
                <div>
                  <div style={estiloEtiqueta}>LO QUE DICE EL BANCO</div>
                  <p style={estiloDato}>{d.medioCobro || ETIQUETAS_FUENTE[c.fuente] || c.fuente} · {fechaCorta(d.fecha)} {d.hora} · <b>{dinero(d.importe)}</b></p>
                  {d.autorizacion && <p style={estiloDato}>Autorización <b>{d.autorizacion}</b>{d.tecleado ? ` · tecleado en la terminal: ${d.tecleado}` : ""}{explicarTecleado(d.tecleado) ? ` (${explicarTecleado(d.tecleado)})` : ""}</p>}
                  {!d.autorizacion && d.folioBanco && <p style={estiloDato}>Folio de pago <b>{d.folioBanco}</b></p>}
                  {d.referencia && c.fuente !== "TARJETA" && <p style={estiloDato}>Referencia con la que pagó: {d.referencia}</p>}
                  {d.matriculaBanco && <p style={estiloDato}>Según la referencia: <b>matrícula {d.matriculaBanco}</b>{conceptosTexto(d.conceptosBanco)}</p>}
                  {!d.matriculaBanco && c.tipo === "SIN_ORDEN" && <p style={estiloDato}>La referencia no dice de qué alumno es.</p>}
                  {(d.partes || []).map((p) => (
                    <p key={p.clave || p.dato} style={estiloDato}>Otra parte del pago: {p.medioCobro.toLowerCase()} del {fechaCorta(p.fecha)} {p.hora} · {datoDe(p)} · <b>{dinero(p.importe)}</b></p>
                  ))}
                  {d.otra && <p style={estiloDato}>El banco tiene <b>otro cobro</b> de esta orden: {d.otra.medioCobro.toLowerCase()} del {fechaCorta(d.otra.fecha)} {d.otra.hora} · {datoDe(d.otra)} · <b>{dinero(d.otra.importe)}</b></p>}
                </div>
              )}
              <div>
                <div style={{ fontSize: "0.75rem", color: "#666" }}>ORDEN EN MULTIPAGOS</div>
                {c.id_intencion ? (
                  <>
                    <p style={estiloDato}>Orden <b>{c.id_intencion}</b>{c.orden_folio ? ` · folio ${c.orden_folio}` : ""} · {c.orden_estatus}</p>
                    {c.orden_matricula && <p style={estiloDato}>Matrícula {c.orden_matricula} · {dinero(c.orden_importe)}</p>}
                    {c.orden_capturado && <p style={estiloDato}>Capturado: {c.orden_capturado}</p>}
                    {(d.otras || []).map((o) => (c.tipo === "FOLIO_DE_OTRO_ALUMNO" ? (
                      <p key={o.orden} style={estiloDato}>Folio tecleado: orden <b>{o.orden}</b>{o.folio ? ` · folio ${o.folio}` : ""} · matrícula {o.matricula} · {o.estatus} · {dinero(o.monto)}</p>
                    ) : (
                      <p key={o.orden} style={estiloDato}>También la pagó: orden <b>{o.orden}</b>{o.folio ? ` · folio ${o.folio}` : ""} · {o.estatus} · {dinero(o.monto)}{o.capturado ? ` · capturado: ${o.capturado}` : ""}</p>
                    )))}
                  </>
                ) : <p style={estiloDato}>No hay orden</p>}
              </div>
            </div>
            {d.nota && <p style={{ ...estiloDato, color: "#666" }}>{d.nota}</p>}
            <p style={{ ...estiloDato, marginTop: "6px" }}><b>Qué hacer:</b> {d.accion}</p>
            {c.estado !== "PENDIENTE" && (
              <p style={{ ...estiloDato, color: (ESTADOS_CASO[c.estado] || {}).color }}>{ESTADO_CAJERO[c.estado]}{c.respuesta ? ` — “${c.respuesta}”` : ""}</p>
            )}
            <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", marginTop: "8px" }}>
              {(c.acciones || []).map((a) => (
                <button key={a} onClick={() => abrir(c, a)} className={a === "RESPONDER" ? "btn-select" : "btn-select validar"}
                  style={a === "RESPONDER" ? { border: "1px solid #003b5c", padding: "6px 12px", backgroundColor: "#fff", color: "#003b5c" } : { border: "none", padding: "6px 12px" }}>
                  {ACCIONES_CASO[a] ? ACCIONES_CASO[a].boton : a}
                </button>
              ))}
            </div>
          </div>
        );
      })}

      {abierto && (
        <div role="dialog" aria-modal="true" aria-label={ACCIONES_CASO[abierto.accion].boton}
          style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 2000, padding: "16px" }}>
          <div style={{ backgroundColor: "#fff", borderRadius: "8px", padding: "20px", width: "100%", maxWidth: "520px" }}>
            <h4 style={{ marginTop: 0, color: "#003b5c" }}>{ACCIONES_CASO[abierto.accion].boton}</h4>
            <p style={{ fontSize: "0.85rem", color: "#555", margin: "0 0 6px 0" }}>{(TIPOS_CASO[abierto.caso.tipo] || { titulo: abierto.caso.tipo }).titulo}{abierto.caso.datos && abierto.caso.datos.accion ? ` — ${abierto.caso.datos.accion}` : ""}</p>
            <p style={{ fontSize: "0.9rem" }}>{ACCIONES_CASO[abierto.accion].explica}</p>
            {abierto.caso.datos && abierto.caso.datos.probable && abierto.accion !== "RESPONDER" && <div style={estiloAviso}>{avisoProbable(abierto.caso.datos)}</div>}
            {(abierto.accion === "CORREGIR_DATO" || abierto.accion === "CAMBIAR_METODO") && (
              <div style={{ fontSize: "0.9rem", backgroundColor: "#f8f9fa", border: "1px solid #ddd", borderRadius: "4px", padding: "8px 10px", marginBottom: "10px" }}>
                <div>Se capturó: <b>{abierto.caso.orden_capturado || "(vacío)"}</b>{abierto.accion === "CAMBIAR_METODO" && abierto.caso.datos.metodo ? ` (${abierto.caso.datos.metodo})` : ""}</div>
                <div>Quedará: <b>{abierto.caso.datos.autorizacion || abierto.caso.datos.folioBanco}</b>{abierto.accion === "CAMBIAR_METODO" ? ` (${abierto.caso.datos.medioCobro})` : ""}, que es lo que dice el banco.</div>
                <div style={{ fontSize: "0.8rem", color: "#666", marginTop: "4px" }}>La orden sigue pagada; solo se corrige el dato. Financieros verá el antes, el después y tu justificación.</div>
              </div>
            )}
            {abierto.accion === "CANCELAR_DUPLICADA" && abierto.caso.datos.otra && (
              <p style={{ fontSize: "0.9rem" }}>El pago ({abierto.caso.datos.otra.medioCobro.toLowerCase()} del {fechaCorta(abierto.caso.datos.otra.fecha)}) se queda en la orden <b>{abierto.caso.datos.otra.orden}</b>; la orden <b>{abierto.caso.id_intencion}</b> se cancela.</p>
            )}
            {pide === "folio_orden" && candidatas.length > 0 && (
              <div style={{ marginBottom: "10px" }} role="radiogroup" aria-label={delAlumno.length ? "Órdenes pendientes del alumno" : "Órdenes pendientes del plantel"}>
                <div style={{ fontWeight: "bold", fontSize: "0.85rem", marginBottom: "4px" }}>
                  {delOtro.length
                    ? "La orden del otro alumno (su folio es el que se tecleó en la terminal)"
                    : delAlumno.length
                    ? `Órdenes pendientes de la matrícula ${abierto.caso.datos.matriculaBanco} por ${dinero(abierto.caso.datos.importe)}`
                    : `La referencia no dice de qué alumno es. Órdenes pendientes del plantel por ${dinero(abierto.caso.datos.importe)} creadas cerca del cobro: elige una solo si el alumno te confirma que es suya.`}
                </div>
                {candidatas.map((o) => (
                  <label key={o.id} style={{ display: "block", fontSize: "0.9rem", padding: "4px 0", cursor: "pointer" }}>
                    <input type="radio" name="caso-candidata" checked={extra === String(o.folio_registro)} onChange={() => setExtra(String(o.folio_registro))} />
                    {" "}Orden {o.id} · folio {o.folio_registro}{o.matricula ? ` · matrícula ${o.matricula}` : ""} · {dinero(o.importe_total)} · creada el {fechaCorta(o.fecha_creacion)}
                  </label>
                ))}
              </div>
            )}
            {pide === "folio_orden" && !candidatas.length && (
              <p style={{ fontSize: "0.85rem", backgroundColor: "#fff8e1", border: "1px solid #ffe082", color: "#7a5c00", borderRadius: "4px", padding: "8px 10px" }}>
                {abierto.caso.datos.matriculaBanco
                  ? `La matrícula ${abierto.caso.datos.matriculaBanco} no tiene una orden pendiente de ${dinero(abierto.caso.datos.importe)} en tu plantel. Búscala en Módulo Alumnos, genera la ficha${conceptosTexto(abierto.caso.datos.conceptosBanco)} y regresa aquí con el folio de la ficha.`
                  : "La referencia no dice de qué alumno es. Pregúntale al alumno, genérale la ficha y regresa con su folio, o usa Responder."}
              </p>
            )}
            {pide === "folio_orden" && (
              <>
                <label htmlFor="caso-folio" style={{ display: "block", fontWeight: "bold", fontSize: "0.85rem", marginBottom: "4px" }}>Folio de la orden (viene en la ficha del alumno)</label>
                <input id="caso-folio" inputMode="numeric" value={extra} onChange={(e) => setExtra(e.target.value.replace(/\D/g, ""))} maxLength={10}
                  style={{ padding: "8px", border: "1px solid #ccc", borderRadius: "4px", width: "100%", marginBottom: "10px", boxSizing: "border-box" }} />
              </>
            )}
            {pide === "dato" && (
              <>
                <label htmlFor="caso-dato" style={{ display: "block", fontWeight: "bold", fontSize: "0.85rem", marginBottom: "4px" }}>Escribe {datoDelComprobante(abierto.caso.datos.medioCobro)}</label>
                <input id="caso-dato" value={extra} onChange={(e) => setExtra(e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, ""))} maxLength={30}
                  style={{ padding: "8px", border: "1px solid #ccc", borderRadius: "4px", width: "100%", marginBottom: "10px", boxSizing: "border-box" }} />
              </>
            )}
            <label htmlFor="caso-motivo" style={{ display: "block", fontWeight: "bold", fontSize: "0.85rem", marginBottom: "4px" }}>Justificación (obligatoria)</label>
            <textarea id="caso-motivo" value={motivo} onChange={(e) => setMotivo(e.target.value)} rows={4} maxLength={1000}
              placeholder={EJEMPLO_JUSTIFICACION[abierto.accion] || "Explica qué pasó y por qué se corrige así."}
              style={{ padding: "8px", border: "1px solid #ccc", borderRadius: "4px", width: "100%", boxSizing: "border-box" }} />
            {motivo.trim().length > 0 && motivo.trim().length < MIN_JUSTIFICACION && <p style={{ fontSize: "0.8rem", color: "#7a5c00" }}>Escribe por lo menos {MIN_JUSTIFICACION} caracteres.</p>}
            <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end", marginTop: "12px" }}>
              <button onClick={() => setAbierto(null)} className="btn-select" style={{ border: "1px solid #999", padding: "8px 14px", backgroundColor: "#fff", color: "#333" }}>Cancelar</button>
              <button onClick={enviar} disabled={!listo || enviando} className="btn-select validar"
                style={{ border: "none", padding: "8px 14px", opacity: (!listo || enviando) ? 0.45 : 1, cursor: (!listo || enviando) ? "not-allowed" : "pointer" }}>
                {enviando ? "Guardando..." : "Confirmar"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VistaCasosPlantel;
